"use strict";

require("core-js/modules/es6.array.find");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _ramda = require("ramda");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background: rgb(235, 235, 235);\n    border-top: 1px solid rgb(224, 224, 224);\n    transition: all .3s;\n    opacity: ", ";\n    transform: scaleY(", ");\n    transform-origin: center 0;\n    overflow: hidden;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n    transition: all .3s;\n    height: 40px;\n    width: 40px;\n    font-size: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    &:hover {\n        background: rgb(235, 235, 235);\n        color: #888;\n        cursor: pointer;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 40px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents.default.div(_templateObject());

var IconWrapper = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var hover = _ref.hover;
  return hover ? '#888' : 'rgb(181, 181, 181)';
}, function (_ref2) {
  var hover = _ref2.hover;
  return hover ? 'rgb(235, 235, 235)' : 'none';
});

var Elements = _styledComponents.default.div(_templateObject3(), function (_ref3) {
  var hover = _ref3.hover;
  return hover ? 1 : 0;
}, function (_ref4) {
  var hover = _ref4.hover;
  return hover ? 1 : 0;
});

var ELEMENTS = [{
  type: 'text',
  icon: _freeSolidSvgIcons.faFont
}, {
  type: 'rect',
  icon: _freeSolidSvgIcons.faSquare
}, {
  type: 'circle',
  icon: _freeSolidSvgIcons.faCircle
}, {
  type: 'curve',
  icon: _freeSolidSvgIcons.faBezierCurve
}, {
  type: 'image',
  icon: _freeSolidSvgIcons.faImage
}, {
  type: 'qr',
  icon: _freeSolidSvgIcons.faQrcode
}];

var Toolbar =
/*#__PURE__*/
function (_Component) {
  _inherits(Toolbar, _Component);

  function Toolbar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Toolbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Toolbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hover: false
    };

    _this.getSelectedIcon = function () {
      var selected = _this.props.selected;
      return selected ? (0, _ramda.find)((0, _ramda.propEq)('type', selected), ELEMENTS).icon : null;
    };

    _this.onMouseEnter = function () {
      return _this.setState({
        hover: true
      });
    };

    _this.onMouseLeave = function () {
      return _this.setState({
        hover: false
      });
    };

    return _this;
  }

  _createClass(Toolbar, [{
    key: "render",
    value: function render() {
      var onSelect = this.props.onSelect;
      var hover = this.state.hover;
      return _react.default.createElement(Container, null, _react.default.createElement(IconWrapper, {
        onClick: function onClick() {
          return onSelect(null);
        }
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faCog
      })), _react.default.createElement("div", {
        onMouseLeave: this.onMouseLeave
      }, _react.default.createElement(IconWrapper, {
        onMouseEnter: this.onMouseEnter,
        hover: hover
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: this.getSelectedIcon() || _freeSolidSvgIcons.faPlus
      })), _react.default.createElement(Elements, {
        hover: hover
      }, ELEMENTS.map(function (element) {
        return _react.default.createElement(IconWrapper, {
          key: element.type,
          onClick: function onClick() {
            return onSelect(element.type);
          }
        }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: element.icon
        }));
      }))));
    }
  }]);

  return Toolbar;
}(_react.Component);

exports.default = Toolbar;
Toolbar.propTypes = {
  selected: _propTypes.default.string,
  onSelect: _propTypes.default.func
};